export default "__VITE_ASSET__DRce_Cma__"